<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import ChartEnergyEfficiency from '$lib/PageSections/Charts/ChartEnergyEfficiency/ChartEnergyEfficiency.svelte';
	import CustomerStory from '$lib/PageSections/CustomerStory/CustomerStory.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import EnergyInAction from '$lib/PageSections/IndowInAction/EnergyInAction.svelte';
	import ProductRecommendation from '$lib/PageSections/Products/ProductRecommendation.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';

	import { ThermalProduct } from '$lib/data/products/products-data.js';
	import { thisOldHouseCustomerStory } from '$routes/(public)/resources/case-studies/customer-stories.js';

	import moldyWindowExampleImage from './images/moldyWindowExample.jpg';
	import pollenInSunlightImage from './images/pollenInSunlight.jpg';
</script>

<Section>
	<h2 class="text-left">Keeping Allergens Out Of Your Home</h2>
	<p class="text-left">
		Many windows have small, nearly invisible cracks or leaks in their seal
		which allow particulate matter inside your home. That's the tiny particles
		of pollen, smoke, car exhaust and other contaminants that decrease your
		indoor air quality and may spike the allergic reactions in you and your
		loved ones.
	</p>
	<Image src={pollenInSunlightImage} loading="eager" />

	<p class="text-left">
		What's even worse is that many windows will collect condensation inside the
		window frame, leading to mold and mildew - an allergen and a health risk!
	</p>

	<Image src={moldyWindowExampleImage} />

	<h2 class="text-left">
		Block Pollen & Pollutants with Indow Thermal Inserts
	</h2>

	<p class="text-left">
		With our patented Snug Fit compression tubing and premium acrylic glazing,
		our <a href="/products/thermal-window-inserts">Thermal Window Inserts</a> reduces
		the amount of cold drafts and heat loss happening through your windows by creating
		a near airtight seal in your windows. This leads to lower energy use - saving
		homeowners an average of 20% per year on energy expenses.
	</p>
	<p class="text-left">
		That airtight seal also keeps particulate matter outside - improving the air
		quality indoors - while drastically reducing condensation by creating a
		barrier between cold winter air and your warm cozy home. It's your secret
		weapon in the fight against allergens in the home.
	</p>
	<p class="text-left">
		But the best part? They blend in with your existing window frames and let
		light flow in freely. In fact, if it wasn't for the cleaner air and lower
		energy bills, you'd hardly notice them!
	</p>
	<EnergyInAction />
</Section>

<CustomerStory story={thisOldHouseCustomerStory} />

<Section>
	<h2 class="text-left">More Quiet, More Comfort, More Savings</h2>

	<p class="text-left">
		In addition to blocking pollutants, <a
			href="/solutions/prevent-window-condensation">preventing condensation</a
		>, and reducing temperature loss, Indow Thermal Inserts also provide
		significant <a href="/solutions/noise-performance">noise reduction</a>,
		keeping your home up to 50% quieter. It's a win-win-win for your pocket
		book, the planet, and your day-to-day health & comfort.
	</p>

	<p class="text-left">
		But that doesn't mean you'll have to live in a hermetically sealed home!
		With a gentle tug on the provided D-ring, you can break the seal and remove
		the inserts whenever you want to open your windows for cleaning.
	</p>
</Section>

<ProductRecommendation product={ThermalProduct} />

<Section backgroundColor="grey-light">
	<h3 class="text-indow-grey-dark">Indow vs Replacement Windows</h3>
	<p>
		Adding Indow inserts to an existing window can make your windows perform as
		well (or better!) than a replacement window, but at a fraction of the cost
		and without the hassle and disruption of installing new windows.
	</p>
	<ChartEnergyEfficiency />
</Section>

<TrustedChoice />
<Reviews />
<GetAFreeEstimate />
